import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var HttpDebugger =
/*#__PURE__*/
function () {
  function HttpDebugger() {
    _classCallCheck(this, HttpDebugger);
  }

  _createClass(HttpDebugger, [{
    key: "debugStartHttpRequest",

    /*
    Called when http request is started
    */
    value: function debugStartHttpRequest() {}
    /*
    Called when http request is resolved
    */

  }, {
    key: "debugSuccessHttpRequest",
    value: function debugSuccessHttpRequest() {}
    /*
    Called when http request is being retried
    */

  }, {
    key: "debugRetryHttpRequest",
    value: function debugRetryHttpRequest() {}
  }]);

  return HttpDebugger;
}();
export var httpDebugger = new HttpDebugger();